import { Link } from 'react-router-dom';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import styles from './NotFoundPage.module.css';

/**
 * 없는 경로.
 * 이전에는 홈으로 리다이렉트했는데, 오타 URL이 200을 반환하는 soft 404가 되어
 * 검색엔진이 같은 홈 화면을 여러 주소로 색인한다. noindex를 붙여 끊는다.
 */
export default function NotFoundPage() {
  useDocumentMeta({ title: '페이지를 찾을 수 없습니다', noIndex: true });

  return (
    <div className={styles.wrap}>
      <p className={styles.code}>404</p>
      <h1 className={styles.title}>페이지를 찾을 수 없습니다</h1>
      <p className={styles.desc}>주소가 바뀌었거나 삭제된 페이지일 수 있어요.</p>
      <Link className={styles.btn} to="/">체험단 둘러보기</Link>
    </div>
  );
}
